/* eslint-disable import/no-cycle */
import { User } from "./User";

export enum ImportType {
  ZIMS = "zims",
  OBSERVATION_GRID = "observationGrid",
  TRAINING = "training",
}

export enum ImportStatus {
  ERROR = "error",
  CANCELED = "canceled",
  INCOMING = "incoming",
  IN_PROGRESS = "in_progress",
  COMPLETE = "complete",
  COMPLETE_WITH_ERRORS = "complete_with_errors",
}

export enum ImportItemStatus {
  TO_ARCHIVE = "to_archive",
  ARCHIVED = "archived",
  ERROR = "error",
  IN_PROGRESS = "in_progress",
  IMPORTED = "imported",
  CANCELED = "canceled",
}

export type ParsedContentType = {
  totalEntries: number;
  totalImported: number;
  totalErrors: number;
  totalInProgress: number;
  totalCanceled: number;
  totalArchived: number;
  data: any[];
};

export type Import = {
  id: string;
  fileName: string;
  author: User;
  parsedContent: ParsedContentType;
  importType: ImportType;
  status: ImportStatus;
  createdAt: any;
  error?: { key: string };
};

type BaseImportItem = {
  id?: number;
  status: ImportItemStatus;
  createdAt: any;
  errorDetails?: { key: string };
  validatedBy?: User | number;
  validatedAt?: any;
};

export interface ImportDetailItemProps<T> {
  item: T & BaseImportItem;
}
